import { Dispatch, SetStateAction } from 'react';

export const handleRichCopy = (
  ref: HTMLDivElement | null,
  setCopied: Dispatch<SetStateAction<boolean>>
) => {
  if (!ref) return;
  setCopied(true);
  setTimeout(() => setCopied(false), 3000);
  window?.getSelection()?.removeAllRanges();
  const range = document.createRange();
  range.selectNode(ref);
  window?.getSelection()?.addRange(range);
  document.execCommand('copy');
  window?.getSelection()?.removeAllRanges();
};
